import { Select } from '@mantine/core';

import Paragraph from '@/components/text/Paragraph.tsx';

import { type MainPractitionerOption } from '@/utils/chain-main-practitioner-utils.ts';

const NO_ELIGIBLE_PRACTITIONER_MESSAGE =
    'Derzeit gibt es keine Hauptbehandler:in, die alle benötigten Schritte in der Terminkette durchführen kann. Bitte wenden Sie sich an den ETERNO Support.';

interface Props {
    options: MainPractitionerOption[];
    value: string | undefined;
    onChange: (practitionerId: string | undefined) => void;
    reselectPrompt?: boolean;
}

export const ChainMainPractitionerSelect = ({ options, value, onChange, reselectPrompt = false }: Props) => {
    const hasNoEligiblePractitioner = options.length === 0;
    const selectData = options.map((option) => ({
        value: option.practitioner_id,
        label: option.display_name,
    }));

    const handleChange = (next: string | null): void => {
        onChange(next ?? undefined);
    };

    return (
        <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
                <Paragraph className="whitespace-nowrap text-sm">Haupt-Behandler:in</Paragraph>
                <Select
                    className="w-64"
                    placeholder="Behandler:in auswählen..."
                    searchable
                    data={selectData}
                    // eslint-disable-next-line unicorn/no-null -- Mantine Select needs `null` (not `undefined`) to represent an empty/cleared value
                    value={value ?? null}
                    onChange={handleChange}
                    disabled={hasNoEligiblePractitioner}
                    allowDeselect={false}
                    error={reselectPrompt ? 'Bitte Hauptbehandler:in erneut wählen.' : undefined}
                />
            </div>
            {hasNoEligiblePractitioner && (
                <Paragraph className="text-xs text-red-500">{NO_ELIGIBLE_PRACTITIONER_MESSAGE}</Paragraph>
            )}
        </div>
    );
};
